/**
 * Shown instead of the app when the local database cannot be opened because it
 * was written by a newer build (lib/db-open-guard.ts). The only way forward is
 * to discard it, so the copy says plainly what is lost — the in-app Reinstall
 * on /sync deliberately keeps data and cannot fix this, and is unreachable here
 * anyway because the app has not booted.
 */
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { resetLocalDatabase } from '@/lib/db-open-guard';

export function DatabaseResetScreen() {
  const [busy, setBusy] = useState(false);

  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="font-heading text-xl font-semibold">This app needs a reset</h1>
      <p className="text-sm text-muted-foreground">
        The data stored on this device was written by a newer version of the app and cannot be opened. Resetting clears
        it and starts fresh. Anything already synced to the office is safe; anything captured on this device and not yet
        synced will be lost.
      </p>
      <Button
        disabled={busy}
        onClick={() => {
          setBusy(true);
          void resetLocalDatabase();
        }}
      >
        {busy ? 'Resetting…' : 'Reset local data'}
      </Button>
    </div>
  );
}
